import React, { Component } from "react";
import isEqual from 'lodash/isEqual'
import { connect } from "react-redux";
import * as actions from "./../../actions";

import PropTypes from 'prop-types';

import {  withStyles} from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import Zoom from '@material-ui/core/Zoom';


const styles = theme => ({
  root:{
    position: "relative",
    height: "70vh",
    minHeight: 400,
    overflow: "hidden",
    background: theme.palette.background.white,
  },
  rootMobile:{
    paddingTop: 56,
  },
  bgImageContainer:{
    position:"absolute",
    top: 0,
    overflow: "hidden",
    height: "70vh",

    width: "100%",
    background: theme.palette.background.dark,
    backgroundImage: "url('https://i.imgur.com/jruqywO.jpg')",
    backgroundSize: "cover",
    clipPath:"polygon(0 0%, 100% 0%, 100% 91%, 90% 87%, 80% 86%, 70% 88%, 60% 90%, 50% 91%, 40% 89%, 30% 92%, 20% 95%, 10% 93%, 0% 94%)",
    "-webkit-clipPath":"polygon(0 0%, 100% 0%, 100% 85%, 90% 87%, 80% 86%, 70% 89%, 60% 90%, 50% 91%, 40% 89%, 30% 92%, 20% 95%, 10% 93%, 0% 97%)",
  },
  bgImage:{
    position:"absolute",
    display: "block",
    top: 0,
    left:0,

    height: "auto",
    width: "100%",
    opacity: 1,

  },

  navbarSpacing:{
    display: "relative",
    height:100,
  },
  titleContainer:{
    zIndex: 1001,
    height: "70vh",

    display: "flex",
    flexDirection: "column",
    justifyContent:"center",
    alignContent:"center",


  },
  titleWrapper:{
    background: theme.palette.background.dark,
    paddingLeft: theme.spacing.unit * 3,
    minWidth: 800,
  },
  title:{
    fontSize: 50,

    textTransform: "uppercase",

    background: theme.palette.background.gold,
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",

    textShadow: theme.shadows[3]

  },
  subTitle:{
    fontSize: 40,
    textShadow: theme.shadows[3],
    minWidth: 1000,

    textTransform: "uppercase",

    color: theme.palette.common.white,
    padding: theme.spacing.unit * 1,

  },
  button:{
    position:"relative",
    zIndex:1002,
    borderWidth: 2,

    height: 90,
    fontSize: 40,
    borderRadius: 5,


    margin: "auto",
    opacity: 0.9
  },

  bottomChart:{
    position: "absolute",
    left: 0,
    bottom: 0,
    height: 100,

    width: "100%",

    marginBottom: -1,
  },

})



class LandingPage extends Component{

  state = {
    titleSmallTransition: false,
    buttonTransition: false,
    timeoutFun: null
  }

  openOrderPage = ()=>{
    this.props.loginDialogState(true)
  }

  componentDidMount(){


    this.setState({timeoutFun: setTimeout(()=>this.setState({buttonTransition: true, titleSmallTransition: true}), 1500)})
  }

  componentDidUpdate(prevProps){



  }

  componentWillUnmount(){
    clearTimeout(this.state.timeoutFun)
  }


  static contextTypes = {
    router: PropTypes.object
  }

  render(){

    const { classes, auth, theme } = this.props

    return(
      <div>
        <Hidden smDown>
          <Grid container className={classes.root} >

              <div className={this.props.classes.bgImageContainer}></div>

              <Grid item xs={12}  className={classes.titleContainer} >

                  <div style={{display:"flex", alignContent: "center", justifyContent:"center"}}>

                      <Grid container >

                        <Grid item xs={12}  style={{display:"flex", justifyContent:"center", flexDirection: "column", alignContent:"center"}}>
                          <Zoom  in={this.state.titleSmallTransition} timeout={500}>
                            <div style={{display:"flex", justifyContent:"flex-start", width:"60%", margin:"auto", padding: theme.spacing.unit * 2}}>
                              <img src="https://i.imgur.com/bnDCUta.png" alt="text" width="auto" height="50"/>
                            </div>
                          </Zoom>
                          <Zoom in={true} timeout={1000}>
                            <div style={{display:"flex", justifyContent:"center", width:"60%", margin:"auto"}}>

                              <img src="https://i.imgur.com/Boi2cXP.png" alt="text" width="100%" height="auto"/>

                            </div>
                          </Zoom>
                          <Zoom  in={this.state.titleSmallTransition} timeout={500}>
                            <div style={{display:"flex", justifyContent:"flex-end", width:"60%", margin:"auto", padding: theme.spacing.unit * 2}}>
                              <img src="https://i.imgur.com/XHxIYLS.png" alt="text" width="auto" height="50"/>
                            </div>
                          </Zoom>
                        </Grid>
                      </Grid>

                  </div>

              </Grid>



            </Grid>
        </Hidden>
        <Hidden mdUp>
            <Grid container className={classes.rootMobile} >

              <Grid item xs={12} style={{display:"flex", justifyContent:"flex-start", flexDirection: "column", alignContent:"center"}}>

              </Grid>

            </Grid>
        </Hidden>
      </div>

    )
  }
}

/*
<Grid item xs={12}>
  {
    auth ? (
      <Button  variant="text" color="secondary"  className={classes.button} fullWidth>
        MOJE NAPOVEDI
      </Button>
    ):(
      <Button onClick={this.openOrderPage} variant="text" color="secondary"  className={classes.button} fullWidth>
        NAROČI SE
      </Button>
    )
  }
</Grid>
<Slide direction="down" in={true} timeout={1000}>
  <div >
    <Typography variant="title" className={classes.subTitle}>
      Betting is not a gamble
    </Typography>
  </div>
</Slide>
<Slide direction="down" in={true} timeout={1000}>
  <div className={classes.titleWrapper}  >
    <Typography variant="subheading" className={classes.title}>
      if you know who to trust!
    </Typography>
  </div>
</Slide>
 */

LandingPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({auth}) => {
  return {
    auth
  };
};

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(LandingPage))



// WEBPACK FOOTER //
// ./src/components/main/LandingPage.js